import { Flex, FlexProps, Image } from "@chakra-ui/react";

export const CenteredExpandedImage: React.FC<{ src: string; alt?: string } & FlexProps> = ({
  src,
  alt = "Image",
  ...rest
}) => (
  <Flex justifyContent="center" alignItems="center" overflow="hidden" {...rest}>
    <Image src={src} alt={alt} objectFit="cover" w='100%' minH="100%" />
  </Flex>
);
